import React from 'react';
import { AppMobileFrame, AppTabletFrame } from '@yme/molecules/app-frames';
import { MOBILE_FRAME_TYPE } from './constants';
import { AppMobileFrameWrapperStyled, AppTabletFrameWrapperStyled } from './styled';
export function AppFrame(props) {
    const { frameType, appImage, isRightToLeft } = props;
    if (frameType === MOBILE_FRAME_TYPE) {
        return (React.createElement(AppMobileFrameWrapperStyled, { isRightToLeft: isRightToLeft },
            React.createElement(AppMobileFrame, { appImage: appImage })));
    }
    return (React.createElement(AppTabletFrameWrapperStyled, { isRightToLeft: isRightToLeft },
        React.createElement(AppTabletFrame, { appImage: appImage, isRightToLeft: isRightToLeft })));
}
AppFrame.displayName = 'AppFrame_Component';
